import { Reducer as Reducer_ } from 'redux';
import {
  IQDExternalCommercialModelsCountActionType as IQDExternalCommercialModelsCountActionType_,
  IQDExternalConsumerModelsCountActionType as IQDExternalConsumerModelsCountActionType_,
  IQDEnabledActionType as IQDEnabledActionType_,
  CountingModel as CountingModel_,
  IRenewalDocumentCountActionType as IRenewalDocumentCountActionType_,
  QDEnabledModel as QDEnabledModel_,
  ICurrentApplicationsCountActionType as ICurrentApplicationsCountActionType_
} from '../actions/counts-qd-enabled-actions';
import * as types from '../actions/actionTypes/count-qd-enabled';

/* eslint-disable max-len */
const requiredDocumentCountFetchedReducer: Reducer_<CountingModel_, IRenewalDocumentCountActionType_> = (state = { isFetched: false, count: 0, }, { type, payload, }) => {
  switch (type) {
    case types.REQUIRED_DOCUMENTS_COUNT_FETCHED:
      return { ...payload, };

    default:
      return state;
  }
};

const qdExternalCommercialModelsCountReducer: Reducer_<CountingModel_, IQDExternalCommercialModelsCountActionType_> = (state = { isFetched: false, count: 0, }, { type, payload, }) => {
  switch (type) {
    case types.QD_EXTERNAL_COMMERCIAL_MODELS_COUNT_FETCHED:
      return { ...payload, };

    default:
      return state;
  }
};

const qdExternalConsumerModelsCountReducer: Reducer_<CountingModel_, IQDExternalConsumerModelsCountActionType_> = (state = { isFetched: false, count: 0, }, { type, payload, }) => {
  switch (type) {
    case types.QD_EXTERNAL_CONSUMER_MODELS_COUNT_FETCHED:
      return { ...payload, };

    default:
      return state;
  }
};

const currentApplicationsCountReducer: Reducer_<CountingModel_, ICurrentApplicationsCountActionType_> = (state = { isFetched: false, count: 0, }, { type, payload, }) => {
  switch (type) {
    case types.CURRENT_APPLICATIONS_COUNT_FETCHED:
      return { ...payload, };
    default:
      return state;
  }
};

const isQDEnabledReducer: Reducer_<QDEnabledModel_, IQDEnabledActionType_> = (state = { isFetched: false, isEnabled: false, }, { type, payload, }) => {
  switch (type) {
    case types.IS_QD_ENABLED:
      return { ...payload, };

    default:
      return state;
  }
};

export {
  requiredDocumentCountFetchedReducer,
  isQDEnabledReducer,
  qdExternalCommercialModelsCountReducer,
  qdExternalConsumerModelsCountReducer,
  currentApplicationsCountReducer
};
